var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        justify: "center",
        value: _vm.value,
        persistent: "",
        "max-width": "400",
      },
    },
    [
      _c("v-card", { attrs: { color: "#fafafa" } }, [
        _c(
          "section",
          { staticClass: "ma-0 pa-6" },
          [
            _c(
              "v-row",
              { attrs: { justify: "center" } },
              [
                _c("v-icon", { attrs: { "x-large": "", color: "red" } }, [
                  _vm._v("mdi-cancel-outline"),
                ]),
              ],
              1
            ),
            _c("v-row", { attrs: { justify: "center" } }, [
              _c("span", { staticClass: "pa-4" }, [
                _vm._v(' Cancel "' + _vm._s(_vm.item.name) + '"? '),
              ]),
              _c("span", { staticClass: "pa-4" }, [
                _vm._v(
                  " Last Updated: " +
                    _vm._s(_vm.formatDateTime(_vm.item.last_updated)) +
                    " "
                ),
              ]),
            ]),
            _c(
              "v-row",
              { staticClass: "pa-4", attrs: { justify: "center" } },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "elevation-1",
                    attrs: { height: "40" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$emit("update:value", false)
                      },
                    },
                  },
                  [_vm._v(" No ")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "white--text ml-2",
                    attrs: { color: "#0c67a5", height: "40" },
                    on: {
                      click: function ($event) {
                        return _vm.cancelItem(_vm.item.id)
                      },
                    },
                  },
                  [_vm._v("Yes ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }